var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('ul',{staticClass:"list-unstyled adjuntos-guardados mb-0",class:{
    'mt-1': _vm.compacto,
    'mt-2': !_vm.compacto,
    'adjuntos-guardados-claro': _vm.tono === 'claro',
    'adjuntos-solo-icono': _vm.soloIcono,
  }},_vm._l((_vm.items),function(adjunto,index){return _c('li',{key:(adjunto.id || adjunto.link || 'adj') + '-' + index},[_c('a',{staticClass:"d-inline-flex align-items-center",attrs:{"href":_vm.urlAdjuntoGuardado(adjunto),"target":"_blank","rel":"noopener noreferrer","title":_vm.soloIcono ? null : _vm.nombreAdjuntoGuardado(adjunto),"data-nombre":_vm.nombreAdjuntoGuardado(adjunto)}},[_c('i',{class:[
          _vm.iconoAdjuntoPorNombre(_vm.nombreAdjuntoGuardado(adjunto)),
          { 'mr-1': !_vm.soloIcono },
        ]}),(!_vm.soloIcono)?_c('span',{staticClass:"text-truncate"},[_vm._v(" "+_vm._s(_vm.nombreAdjuntoGuardado(adjunto))+" ")]):_vm._e()])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }